import { gql } from "@apollo/client";

export const CREATE_VOUCHER = gql`
  mutation createVoucher($input: createVoucherInput) {
    createVoucher(input: $input) {
      voucher_id
    }
  }
`;

export const DELETE_VOUCHER_BY_ID = gql`
  mutation deleteVoucherById($id: Int) {
    deleteVoucherById(id: $id)
  }
`;

export const GET_ALL_VOUCHERS = gql`
  query getAllVouchers {
    getAllVouchers {
      voucher_id
      temple_id
      purpose
      payee_name
      payment_mode
      amount
      description
      reference_no
      attachment_url
      created_at
      created_by_user_id
      l1Status
      l2Status
      l1ApprovedBy
      l2ApprovedBy
     
    }
  }
`;

export const GET_ALL_VOUCHERS_WITH_PAGINATION = gql`
  query getAllVouchersWithPagination($input: PaginationInput) {
    getAllVouchersWithPagination(input: $input) {
      data {
        voucher_id
        temple_id
        purpose
        payee_name
        payment_mode
        amount
        description
        reference_no
        attachment_url
        created_at
        created_by_user_id
        l1Status
        l2Status
        l1ApprovedBy
        l2ApprovedBy
      }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;

export const GET_VOUCHER_BY_ID = gql`
  query getVoucherById($id: Int) {
    getVoucherById(id: $id) {
      voucher_id
      type
      created_at
      number
     reference_no
      partyId
      currency
      status
     created_by_user_id
      l1Status
      l2Status
      l1ApprovedBy
      l2ApprovedBy
    }
  }
`;

// ✅ NEW - APPROVE
export const APPROVE_VOUCHERS = gql`
  mutation approveVouchers($input: voucherApprovalInput) {
    approveVouchers(input: $input)
  }
`;

// ✅ NEW - REJECT
export const REJECT_VOUCHERS = gql`
  mutation rejectVouchers($input: voucherApprovalInput) {
    rejectVouchers(input: $input)
  }
`;
